import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Button, Container, FormField, Input, KeyValuePairs, RadioGroup, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { format } from 'date-fns';
import CurrencyInput from '../../../../../components/CurrencyInput';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import Spacer from '../../../../../components/extras/Spacer';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIcon, btnIconForm, ItemsMovement } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, formatCurrency, getAccountPlan, getCookie, getUrlVersion, getUser, setData, setLoading, setParameters } from '../../../../commons/functions';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';



export const AdminMovementsReversePage = () => {
    //const storeAdmin = useStoreAdmin();
    const { data, menu, parameters } = useGlobalState();

    const [movement, setMovement] = useState<ItemsMovement>();
    const [returnType, setReturnType] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [searching, setSearching] = useState(false);
    const [returnAmmount, setReturnAmmount] = useState(0);
    useGlobalState();



    const { navigate } = useRouter();

    const dismissMessages = () => addNotification(data.status, "error", setData);;


    const handleReverse = async () => {
        try {
            setLoading(true);
            let value = returnAmmount
            if (movement) {
                if (movement?.ammount > 0) value = value * -1
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/update',
                        'JWT': getCookie("JWT"),

                    },

                    body: JSON.stringify({
                        idMovement: 0,
                        ammount: value,
                        idUser: movement?.idUser,
                        idAccountPlan: movement?.idAccountPlan,
                        dateTransaction: format(new Date(), "dd-MM-yyyy"),
                        obs: movement?.obs || "",
                        data: `Reverso ${movement.ammount > 0 ? "Abono" : "Cargo"} #${movement?.idMovement}`,
                    })
                });
                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
                const dataWeb = await response.json();
                if (dataWeb.code === 0) {


                    setMovement(undefined)
                    setReturnType("")
                    setReturnAmmount(0)

                    addNotification("Reverse ejecutado correctamente", 'success', setData);
                } else {
                    addNotification(dataWeb.status, 'error', setData);
                }

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones2: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false);
        }
    };
    const handleSearchMovement = async () => {
        try {
            setSearching(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/movement',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    idMovement: parameters.idMovement
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
            const dataWeb = await response.json();
            if (dataWeb.code === 0) {
                setMovement(dataWeb.movement)
                setReturnType("")
                setReturnAmmount(0)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setSearching(false);
        }
    };
    useEffect(() => {

    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header actions={<Favorites />} variant="h1">Reverso</Header>

                    <SpaceBetween direction='horizontal' size='xs'>
                        <FormField label="Identificador">
                            <Input value={parameters.idMovement} onChange={(event) => {

                                const updatedParameters = {
                                    ...parameters, // clone existing keys
                                    idMovement: event.detail.value // add or update
                                };
                                setParameters(updatedParameters);
                            }} />
                        </FormField>
                        <FormField label={<div style={{ color: "white" }}>{"·"}</div>}>
                            <Button style={{ root: btnIconForm }} loading={searching} onClick={handleSearchMovement}><Icon path={mdiMagnify} size={1} /></Button>
                        </FormField>
                    </SpaceBetween>
                    {movement && (parameters.idMovement ?? 0) > 0 && (
                        <Container>
                            <SpaceBetween direction='vertical' size='xs'>
                                <KeyValuePairs columns={3}
                                    items={[
                                        { label: "Usuario", value: getUser(movement.idUser || 0, data)?.displayName },
                                        { label: "Glosa", value: movement.data },
                                        { label: `${movement.ammount < 0 ? "Cargo" : "Abono"}`, value: Math.abs(movement.ammount) },
                                        { label: "Cuenta", value: getAccountPlan(movement.idAccountPlan || 0, data)?.accountPlan },
                                    ]}
                                >
                                </KeyValuePairs>
                                <Spacer />
                                <Alert
                                    type="info"
                                    header="Tipo de reverso"
                                >
                                    Seleccione el tipo de reverso a aplicar
                                    <RadioGroup
                                        onChange={({ detail }) => {
                                            setReturnType(detail.value)
                                            if (detail.value === "TOTAL") {
                                                setReturnAmmount(Math.abs(movement.ammount))
                                            }
                                        }}
                                        value={returnType}
                                        items={[
                                            { value: "TOTAL", label: "Total [" + formatCurrency(movement.ammount, "CLP") + "]" },
                                            { value: "PARTIAL", label: "Parcial" }
                                        ]}
                                    />
                                    {returnType == "PARTIAL" && (
                                        <div style={{ width: 240 }}>

                                            <SpaceBetween direction='vertical' size='xs'>
                                                <FormField label={"Monto parcial de devolución"}
                                                    constraintText={`Máximo ${Math.abs(movement.ammount)}`}>
                                                    <CurrencyInput value={returnAmmount}
                                                        onChange={(v) => {
                                                            let value = Math.abs(v);
                                                            if (value > Math.abs(movement.ammount)) value = Math.abs(movement.ammount)
                                                            setReturnAmmount(value)
                                                        }} />
                                                </FormField>
                                            </SpaceBetween>


                                        </div>
                                    )}
                                    {returnType !== "" && (
                                        <>
                                            <Spacer />
                                            <div style={{ width: 240 }}>

                                                <FormField label={"Observaciones"}
                                                    constraintText={`Opcional`}>

                                                    <Input value={movement.obs || ""} onChange={(event) => {
                                                        setMovement({ ...movement, obs: event.detail.value })
                                                    }} />
                                                </FormField>
                                            </div>
                                        </>
                                    )}
                                    <Spacer />
                                    <Button variant='primary' disabled={((returnAmmount <= 0 || returnAmmount > Math.abs(movement.ammount)) && returnType === "PARTIAL") || returnType === ""} onClick={() => setShowConfirm(true)}>Generar</Button>
                                </Alert>
                                <ConfirmDelete show={showConfirm} confirmWord={'reversar'} header='Confirmación de reverso' action={'Confirmar'} warning={`Esta acción generará un contra movimiento por ${returnAmmount}`} onConfirm={() => {
                                    handleReverse()
                                    setShowConfirm(false)
                                }}
                                    onDismiss={() => setShowConfirm(false)}

                                />

                            </SpaceBetween>

                        </Container>
                    )}

                </SpaceBetween>
            }
        />
    );
};
